import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/api-client.js';
import { money, orderStatusLabel } from '../utils/admin-format.js';

export function AdminOrdersPage() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  function load() {
    setLoading(true);
    setError('');
    return api.adminOrders({ search, status })
      .then((response) => setRows(response.data))
      .catch((caught) => setError(caught.message))
      .finally(() => setLoading(false));
  }

  useEffect(() => { load(); }, [status]);

  return <section>
    <header className="admin-page-head"><div><p className="admin-eyebrow">Opérations</p><h1>Commandes</h1><p>Confirmez et suivez chaque commande sans quitter ce panneau.</p></div><span>{rows.length} résultat(s)</span></header>
    <form className="admin-toolbar" onSubmit={(event) => { event.preventDefault(); load(); }}>
      <input placeholder="Commande, client ou téléphone" value={search} onChange={(event) => setSearch(event.target.value)} />
      <select value={status} onChange={(event) => setStatus(event.target.value)}>
        <option value="">Tous les statuts</option><option value="pending">À confirmer</option><option value="sbc-confirmed">Confirmée</option><option value="sbc-preparing">En préparation</option><option value="sbc-shipped">Expédiée</option><option value="sbc-delivered">Livrée</option><option value="sbc-refused">Refus client</option><option value="cancelled">Annulée</option>
      </select>
      <button className="btn btn-primary">Filtrer</button>
    </form>
    {error && <div className="admin-alert">{error}</div>}
    <div className="admin-table-wrap"><table className="admin-table"><thead><tr><th>Commande</th><th>Client</th><th>Destination</th><th>Articles</th><th>Total</th><th>Statut</th><th>Action</th></tr></thead><tbody>
      {loading ? <tr><td colSpan="7">Chargement…</td></tr> : rows.length === 0 ? <tr><td colSpan="7">Aucune commande ne correspond aux filtres.</td></tr> : rows.map((row) => <tr key={row.id}><td><strong>#{row.order_number}</strong><small>{new Date(row.created_at).toLocaleString('fr-MA')}</small></td><td><strong>{row.customer_first_name} {row.customer_last_name}</strong><small>{row.customer_phone}</small></td><td>{row.customer_city || '—'}</td><td>{row.item_count}</td><td><strong>{money(row.total_amount_cents)}</strong></td><td><span className={`admin-status status-${row.status}`}>{orderStatusLabel(row.status)}</span></td><td><Link className="admin-link" to={`/admin/commandes/${row.id}`}>Ouvrir</Link></td></tr>)}
    </tbody></table></div>
  </section>;
}
